export default __webpack_public_path__ + "static/media/food-4.844d39dc.png";